import { Typography } from '@mui/material'
import { useProductPageContext } from '../../contexts/ProductPageContext'

type Props = {
  sku: string
}

export function ProductSku(props: Props) {
  const { sku } = props
  const { configuredVariantSku } = useProductPageContext()
  return (
    <Typography variant='body1' component='span' sx={{ color: 'text.disabled' }}>
      {configuredVariantSku || sku}
    </Typography>
  )
}
